import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import ErrorBoundary from './components/ErrorBoundary';
import OfflineBanner from './components/OfflineBanner';
import AuthGate from './screens/AuthGate';
import App from './App';

const loader = document.getElementById('app-loader');
if (loader) loader.style.display = 'none';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ErrorBoundary>
        <OfflineBanner />
        <AuthGate>
            <App />
        </AuthGate>
    </ErrorBoundary>
);
